var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(
      _vm.$route.path != '/login' && _vm.$route.path != '/course/quizWeb'
        ? true
        : false
    )?_c('Navbar',{directives:[{name:"show",rawName:"v-show",value:(_vm.show_navbar),expression:"show_navbar"}],ref:"navbar_comp",attrs:{"primaryColor":_vm.primaryColor}}):_vm._e(),_c('v-main',{staticClass:"bg"},[_c('router-view',{staticStyle:{"padding-top":"1rem !important","padding-left":"1.6rem !important"},attrs:{"primaryColor":_vm.primaryColor},on:{"toggleNavBarCall":_vm.toggleNavBarCall}})],1),_c('BlockOverlay',{attrs:{"show":_vm.secureMode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }